var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconJobsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7836 0.969971H6.21642C2.92949 0.969971 0.969971 2.92949 0.969971 6.21642V13.7836C0.969971 17.0705 2.92949 19.03 6.21642 19.03H13.7836C17.0705 19.03 19.03 17.0705 19.03 13.7836V6.21642C19.03 2.92949 17.0705 0.969971 13.7836 0.969971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6981 7.1736C15.6981 7.54383 15.4001 7.85085 15.0208 7.85085H10.28C9.9098 7.85085 9.60278 7.54383 9.60278 7.1736C9.60278 6.80336 9.9098 6.49634 10.28 6.49634H15.0208C15.4001 6.49634 15.6981 6.80336 15.6981 7.1736Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16698 6.29769L6.13522 8.32944C5.99977 8.46489 5.8282 8.5281 5.65663 8.5281C5.48506 8.5281 5.30446 8.46489 5.17804 8.32944L4.50078 7.65219C4.22988 7.39032 4.22988 6.95688 4.50078 6.69501C4.76265 6.43314 5.18707 6.43314 5.45797 6.69501L5.65663 6.89367L7.20979 5.3405C7.47166 5.07863 7.89607 5.07863 8.16698 5.3405C8.42885 5.60237 8.42885 6.03582 8.16698 6.29769Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6981 13.4946C15.6981 13.8648 15.4001 14.1719 15.0208 14.1719H10.28C9.9098 14.1719 9.60278 13.8648 9.60278 13.4946C9.60278 13.1244 9.9098 12.8174 10.28 12.8174H15.0208C15.4001 12.8174 15.6981 13.1244 15.6981 13.4946Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16698 12.6187L6.13522 14.6505C5.99977 14.7859 5.8282 14.8491 5.65663 14.8491C5.48506 14.8491 5.30446 14.7859 5.17804 14.6505L4.50078 13.9732C4.22988 13.7113 4.22988 13.2779 4.50078 13.016C4.76265 12.7542 5.18707 12.7542 5.45797 13.016L5.65663 13.2147L7.20979 11.6615C7.47166 11.3997 7.89607 11.3997 8.16698 11.6615C8.42885 11.9234 8.42885 12.3568 8.16698 12.6187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconJobsActive);
export default __webpack_public_path__ + "static/media/menu_icon_jobs_active.727228eb0eb09b5e8b3c4c73c3776a33.svg";
export { ForwardRef as ReactComponent };